export default __webpack_public_path__ + "static/media/marching-band.5a0f00a4.jpg";